import vLoading from "./v-loading.vue";

export default Vue => {
  Vue.component("v-loading", vLoading);
};
